export default {"src":"/_next/static/media/Group 427320986.129bf982.svg","height":11,"width":9,"blurWidth":0,"blurHeight":0};